export const MessageType = {
    SUBSCRIBED: 'subscribed',
    CHOOSE_TOPIC: 'choose_topic',
    START_TOPIC:'start_topic',
    FINISH_TOPIC: 'finish_topic',
    PAUSE_TOPIC: 'pause_topic',
    CHANGE_TOPIC_DURATION: 'change_topic_duration',
    CHANGE_TOPIC_POSITION: 'change_topic_position',
    CHANGE_TOPIC_ANSWER: 'change_topic_answer',
    FINISH_MEET: 'finish_meet',
    CREATE_COMMENT: 'create_comment',
    USER_ENTER: 'user_enter',
    USER_LEFT: 'user_left'
}